import { createContext } from 'react';

export const CaseConfigContext = createContext(null);
